"use client"

import { ErrorBanner } from "@/components/ui/error-banner"
import { useCustomSearchParams } from "@/hooks/use-search-params"
import { trackAnalyticsEvent } from "@/lib/analytics"
import { useTranslations } from "next-intl"
import { useEffect } from "react"

export function ServiceErrorBanner() {
  const [searchParams, setSearchParams] = useCustomSearchParams()

  const t = useTranslations()

  const titleKey = "ServiceErrorBanner.title"
  const title = t(titleKey)

  const showServiceErrorBanner =
    searchParams.get("errorBanner") === "serviceError"

  useEffect(() => {
    if (!showServiceErrorBanner) return

    trackAnalyticsEvent({
      event: "link_click",
      event_name: "login_error",
      conversion_pagename: "login",
      error_message: title,
    })
  }, [showServiceErrorBanner, title])

  const handleClick = () => {
    setSearchParams((searchParams) => {
      searchParams.delete("errorBanner")
      return searchParams
    })
  }

  if (!showServiceErrorBanner) return null

  return (
    <ErrorBanner
      title={titleKey}
      body="ServiceErrorBanner.body"
      onClick={handleClick}
    />
  )
}
